import CryptoJS from "crypto-js";

const SECRET_KEY = import.meta.env.VITE_LOGIN_SECRET_KEY; // Replace this with a strong secret key

// Encrypt function
export const encryptID = (id) => {
  const ciphertext = CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();
  return encodeURIComponent(ciphertext); // Encode it for safe URL usage
};

// Decrypt function
export const decryptID = (ciphertext) => {
  const bytes = CryptoJS.AES.decrypt(decodeURIComponent(ciphertext), SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const encryptData = (data) => {  
  return CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
};